import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { PositionerAbsolute, PositionerFixed, PositionerRelative } from '../styled/Modal';

var Positioner = function Positioner(_ref) {
  var scrollBehavior = _ref.scrollBehavior,
      props = _objectWithoutProperties(_ref, ["scrollBehavior"]);

  // default 'inside'
  var PositionComponent = PositionerAbsolute;

  if (scrollBehavior === 'outside') {
    PositionComponent = PositionerRelative;
  } else if (scrollBehavior === 'inside-wide') {
    PositionComponent = PositionerFixed;
  }

  return /*#__PURE__*/React.createElement(PositionComponent, props);
};

export default Positioner;